export default __webpack_public_path__ + "static/media/number-bg.9d6cd4da.webp";